import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiMatchsService } from '../../../../services/matchs/api/api-matchs.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-match-table-edit-modal',
  templateUrl: './match-table-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class MatchTableEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  matchTableId: number = 0;
  name: string = '';
  levelMinimumRequired: number = 0;
  levelExperienceRewardQuantity: number = 0;
  leaguePointRewardQuantity: number = 0;
  leaguePointRewardQuantity2: number = 0;
  hammerRewardQuantity: number = 0;
  creditRewardQuantity1: number = 0;
  creditRewardQuantity2: number = 0;
  creditRewardQuantityDraw: number = 0;
  matchCost: number = 0;
  matchRank: number = 0;
  variantId: number = 0;

  private callbackSaved?: () => void;

  constructor(private apiMatchsService: ApiMatchsService, private alertsService: AlertsService) {}

  show(
    matchTableId: number,
    name: string,
    levelMinimumRequired: number,
    levelExperienceRewardQuantity: number,
    leaguePointRewardQuantity: number,
    leaguePointRewardQuantity2: number,
    hammerRewardQuantity: number,
    creditRewardQuantity1: number,
    creditRewardQuantity2: number,
    creditRewardQuantityDraw: number,
    matchCost: number,
    matchRank: number,
    variantId: number,
    callbackSaved?: () => void
  ): void {
    this.callbackSaved = callbackSaved;
    this.matchTableId = matchTableId;
    this.name = name;
    this.levelMinimumRequired = levelMinimumRequired;
    this.levelExperienceRewardQuantity = levelExperienceRewardQuantity;
    this.leaguePointRewardQuantity = leaguePointRewardQuantity;
    this.leaguePointRewardQuantity2 = leaguePointRewardQuantity2;
    this.hammerRewardQuantity = hammerRewardQuantity;
    this.creditRewardQuantity1 = creditRewardQuantity1;
    this.creditRewardQuantity2 = creditRewardQuantity2;
    this.creditRewardQuantityDraw = creditRewardQuantityDraw;
    this.matchCost = matchCost;
    this.matchRank = matchRank;
    this.variantId = variantId;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiMatchsService.editMatchTable(
      this.matchTableId,
      this.name,
      this.levelMinimumRequired,
      this.levelExperienceRewardQuantity,
      this.leaguePointRewardQuantity,
      this.leaguePointRewardQuantity2,
      this.hammerRewardQuantity,
      this.creditRewardQuantity1,
      this.creditRewardQuantity2,
      this.creditRewardQuantityDraw,
      this.matchCost,
      this.matchRank,
      this.variantId
    ).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Match table updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating match table : ' + error);
      }
    );
  }
}
